var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:[
    'layout-footer',
    _vm.layoutClasses
]},[_c('div',{staticClass:"wrapper wrapper--relative flex"},[_c('div',{staticClass:"flex flex-space-35"},[_c('div',{directives:[{name:"bastards",rawName:"v-bastards"}],staticClass:"fs-13 text-color-light"},[_vm._v("\n                © MAKRO Cash and Carry Polska S.A.\n            ")]),_c('NavigationFooter',{staticClass:"fs-13 text-color-light",attrs:{"items":_vm.navItems}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }